import instance from "services/axiosServices";
import { useQuery } from "@tanstack/react-query";

/**
 * @function fetchListarProdutos
 * @returns {Promise<any>} - retorna a listagem de produtos de acordo com os filtros.
 */
export function fetchListarProdutos(enabled?: boolean) {
  const fetchData = async () => {
    const url = "/locais/admin/produtosvisitas/listar/v1?status=true";
    const response = await instance.get(url);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["fetch-listar-produtos"],
    refetchOnMount: false,
    enabled: enabled ?? false,
  });
  return query;
}

/**
 * @function getListarProdutos
 * @returns {Promise<any>} - retorna a listagem de produtos de acordo com os filtros.
 */
export const getListarProdutos = async (): Promise<any> => {
  const url = "/locais/admin/produtosvisitas/listar/v1?status=true";
  const response = await instance.get(url);
  return response?.data;
};
